<template>
<div class="addnewapp-component page-wrap center-item-to-body">
  <div class="container-box">
    <div class="container-box__logo">
      <router-link to="/">
        <img alt="beurer logo" class="logo_src" src="@/assets/logo_beurer.png">
      </router-link>
    </div>

    <div class="container-box__content">
      <div class="addnewapp-component__form">
        <h1 class="form-title">Add New App</h1>
        <!-- New Name -->
        <div class="form-group">
          <p class="error" v-if="!validateName()">Name is mandatory</p>
          <label for="newAppName" class="input-label">App Name:</label>
          <input class="input-text" type="text" name="newAppName" id="newAppName" placeholder="New App Name" v-model="name">
        </div>
        <!-- New Colors -->
        <div class="form-group addnewapp-component__app-colors">
          <label for="newAppPrimaryColor" class="input-label">App Primary Color:</label>
          <input class="input-color" type="color" name="newAppPrimaryColor" id="newAppPrimaryColor" v-model="primary">
          <label for="newAppSecondaryColor" class="input-label">App Secondary Color:</label>
          <input class="input-color" type="color" name="newAppSecondaryColor" id="newAppSecondaryColor" v-model="secondary">
        </div>
        <!-- New Fonts -->
        <div class="form-group addnewapp-component__app-font">
          <label for="newAppFont" class="input-label">App Font:</label>
          <input class="input-text" type="text" name="newAppFont" id="newAppFont" placeholder="New App Font" v-model="font">
        </div>
        <button class="btn addnewapp_btn" name="addNewAppSubmit" id="addNewAppSubmit" @click="onclickNewAppSubmit()">
          Add New App
        </button>
        <p class="error" v-show="validationError">{{validationError}}</p>
      </div>
    </div>

  </div>
</div>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex'
import ApiService from '@/services/ApiService'
// import TheCategoryCheckbox from '@/components/TheCategoryCheckbox'

export default {
  name: 'addnewapp',
  components: {
    // TheCategoryCheckbox
  },
  data: function () {
    return {
      apiService: new ApiService(),
      name: '',
      // eslint-disable-next-line
      _id: -1,
      logoUrl: '/img/logo_placeholder.png',
      documents: [],
      colors: {},
      primary: '',
      secondary: '',
      font: 'Helvetica, sans-serif',
      appDataInput: '',
      validationError: ''
    }
  },
  mounted () {
    this.createNewApp()
  },
  methods: {
    validateName () {
      if (document.querySelector('#newAppName') === null || document.querySelector('#newAppName') === undefined) {
        return false
      } else {
        this.newDataInput = document.querySelector('#newAppName').value
        if (this.newDataInput === '' || this.newDataInput === ' ' || this.newDataInput === null || this.newDataInput === undefined) {
          return false
        }
        return true
      }
    },
    createNewApp () {
      this.name = ''
      this.primary = '#ffffff'
      this.secondary = '#000000'
      this.font = 'Helvetica, sans-serif'
      this.documents = [{
        'documentId': 1,
        'title': 'GDPR',
        'enabled': true,
        'languages': []
      },
      {
        'documentId': 2,
        'title': 'Datenschutz',
        'enabled': true,
        'languages': []
      },
      {
        'documentId': 3,
        'title': 'Impressum',
        'enabled': true,
        'languages': []
      },
      {
        'documentId': 4,
        'title': 'Kontakt',
        'enabled': true,
        'languages': []
      }
      ]
    },
    onclickNewAppSubmit () {
      var sendObj = {
        'appSettings': [{
          'appId': -1,
          'appName': this.name,
          'logoUrl': this.logoUrl,
          'colors': {
            'primary': this.primary,
            'secondary': this.secondary
          },
          'font': this.font,
          'documents': this.documents
        }]
      }

      // console.log('this.validateName()', this.validateName())
      if (this.validateName()) {
        this.apiService.addNewApp(sendObj)
        this.$router.push('/')
      } else {
        this.validationError = 'Please fill out the name to submit new app'
        // console.log(this.validationError)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/scss/main.scss";

.addnewapp-component {
  .container-box__content {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
  }

  &__form {
    margin: 0 0 auto rem(20);
    text-align: left;

    .form-title {
      margin: 0 0 rem(12) rem(12);
    }

    .form-content {
      margin: 0 0 rem(12) rem(12);
    }

    .form-group {
      margin: 0 rem(12) rem(24) 0;

      .input-label {
        padding: 0 0 rem(12) 0;
        font-weight: bold;
      }

      .input-text {
        margin: auto rem(12) rem(4) rem(12);
        padding: rem(4);
        width: rem(250);
      }

      .input-color {
        margin: auto rem(12) rem(4) rem(12);
        width: rem(25);
      }
    }
  }

  .error {
    font-size: rem(12);
    color: $danger;
  }
}
</style>
